import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../state";

export const createOvertime = createAsyncThunk('createOvertime', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/overtime',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteOvertime = createAsyncThunk('deleteOvertime', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/overtime?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editOvertime = createAsyncThunk('editOvertime', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/overtime',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const approveOvertimeHead = createAsyncThunk('approveOvertimeHead', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/overtime/approve/head',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const approveOvertimeHr = createAsyncThunk('approveOvertimeHr', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/overtime/approve/hr',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})